import * as React from 'react';
import { AppContext } from '../../Context/app-state';
import { TShape } from '../../Data/data';
import './Filter-Shape.css';

export default function FilterShape() {
  const { filters, setFilters } = React.useContext(AppContext);
  const { ball, bell, cone, snowflake, toy } = filters.shape;

  const handleShapeChange = (event: React.MouseEvent<HTMLElement>) => {
    const checkedShape = (event.target as Element).id as TShape;
    setFilters({
      ...filters,
      shape: { ...filters.shape, [checkedShape]: !filters.shape[checkedShape] },
    });
  };

  return (
    <div className="filter-shape" onClick={handleShapeChange}>
      Форма:
      <div className={`shape-ball ${ball ? 'active' : ''}`}>
        <img id="ball" src="./assets/svg/ball.svg" alt="" />
      </div>
      <div className={`shape-bell ${bell ? 'active' : ''}`}>
        <img id="bell" src="./assets/svg/bell.svg" alt="" />
      </div>
      <div className={`shape-cone ${cone ? 'active' : ''}`}>
        <img id="cone" src="./assets/svg/cone.svg" alt="" />
      </div>
      <div className={`shape-snowflake ${snowflake ? 'active' : ''}`}>
        <img id="snowflake" src="./assets/svg/snowflake.svg" alt="" />
      </div>
      <div className={`shape-toy ${toy ? 'active' : ''}`}>
        <img id="toy" src="./assets/svg/toy.svg" alt="" />
      </div>
    </div>
  );
}
